"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTypeCosts = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const isGreaterOrEqualValidator_1 = require("../validators/isGreaterOrEqualValidator");
let VehicleTypeCosts = class VehicleTypeCosts {
    vehicleType;
    driverPricePerHour = 0;
    driverWaitingPricePerHour = 0;
    amortisationPrice;
    consumptionPrice;
    locationMinimalPrice;
    /**
     * The minimal price drivers are willing to accept for their engagement, regardless of trip distance
     */
    tripMinimumPrice;
    /**
     * The minimal price drivers are willing to accept for their engagement, regardless of trip distance
     */
    tripMinimumPriceUpTo;
    /**
     * Coefficient allows for dynamic adjustments to the standard fee based on various conditions or criteria, ensuring flexibility in pricing models.
     * It is expressed as a percentage and stored as a decimal number subtracted from 1, eg. 23% fee coefficient is stored as 0.77.
     * @example 0.77
     */
    feeCoefficient;
};
exports.VehicleTypeCosts = VehicleTypeCosts;
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "vehicleType", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "driverPricePerHour", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "driverWaitingPricePerHour", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "amortisationPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "consumptionPrice", void 0);
__decorate([
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "locationMinimalPrice", void 0);
__decorate([
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "tripMinimumPrice", void 0);
__decorate([
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, isGreaterOrEqualValidator_1.IsGreaterOrEqual)("tripMinimumPrice"),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "tripMinimumPriceUpTo", void 0);
__decorate([
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypeCosts.prototype, "feeCoefficient", void 0);
exports.VehicleTypeCosts = VehicleTypeCosts = __decorate([
    (0, class_transformer_1.Exclude)()
], VehicleTypeCosts);
//# sourceMappingURL=VehicleTypeCosts.js.map